import { useCallback, useRef } from "react";

// Collects DOM nodes for the curved SVG connector between the selected song row and the selected voice. Mobile and desktop layouts each call this hook separately (both are in the DOM), so refs never collide between breakpoints.
export const useConnectorRefs = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const fromRefs = useRef<Map<string, HTMLElement>>(new Map());
  const toRefs = useRef<Map<string, HTMLElement>>(new Map());

  // Keys: song label (same as ShowcaseSong.label) for the "from" side of the line.
  const registerFromRef = useCallback((key: string, el: HTMLElement | null) => {
    if (el !== null) {
      fromRefs.current.set(key, el);
    } else {
      fromRefs.current.delete(key);
    }
  }, []);

  // Keys: showcase artist id strings (same keys as ShowcaseSong.conversions).
  const registerToRef = useCallback(
    (artistId: string, el: HTMLElement | null) => {
      if (el !== null) {
        toRefs.current.set(artistId, el);
      } else {
        toRefs.current.delete(artistId);
      }
    },
    []
  );

  return { containerRef, fromRefs, toRefs, registerFromRef, registerToRef };
};
